<template>
	<div class="components">
		<!-- <div class="searchLine">
			<div class="search">
				<div class="searchL">
				</div>
				<div class="searchR">
					<el-button type="primary" icon="el-icon-document-add" @click="openDialog">添加消费卡</el-button>
				</div>
			</div>
		</div> -->
		<el-table class="table" :data="tableData" style="width: 100%">
			<el-table-column prop="card_name" label="消费卡名称" width="200">
			</el-table-column>
			<el-table-column label="消费卡类型" width="100">
				<template slot-scope="scope">
					{{scope.row.card_category.name}}
				</template>
			</el-table-column>
			<el-table-column prop="card_number" label="消费卡号" width="150">
			</el-table-column>
			<el-table-column prop="service_name"  label="服务" width="200">
			</el-table-column>
			<el-table-column prop="service_object_name" label="规格" width="150">
			</el-table-column>
			<el-table-column prop="surplus_count" label="剩余次数" width="80">
			</el-table-column>
			<el-table-column prop="name" label="状态" >
				<template slot-scope="scope">
					<span v-if="scope.row.status===-1">删除</span>
					<span v-if="scope.row.status===1">启用</span>
					<span v-if="scope.row.status===0">禁用</span>
				</template>
			</el-table-column>
			<el-table-column prop="name" label="截止日期" width="160">
				<template slot-scope="scope">
					{{$public.FTime(scope.row.end_date)}}
				</template>
			</el-table-column>
			<el-table-column prop="name" label="操作">
				<template slot-scope="scope">
					<span
					v-if="scope.row.consume_record"
					style="cursor: pointer;color:#409EFF"
					@click="toConsumerCardRecord(scope.row)">
						查看记录
					</span>
				</template>
			</el-table-column>
		</el-table>
		<!-- <el-dialog title="添加消费卡" :visible.sync="dialogState" width="1000px">
			<el-form :model="form">
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="类型：" :label-width="formLabelWidth">
							<el-radio-group v-model="form.card_type" @change="changeRadio">
								<el-radio :label="1">洗护卡</el-radio>
								<el-radio :label="2">医疗套餐卡</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="服务：" :label-width="formLabelWidth">
							<el-select class="select" v-model="form.service_id" placeholder="请选择服务">
								<el-option v-for="item in serviceList" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="10" :offset="1">
						<el-form-item label="有效期(整数)：" :label-width="formLabelWidth">
							<el-input style="width:230px;" v-model="form.years" autocomplete="off" placeholder="请输入有效期">
								<template slot="append">年</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div class="form">
				<div style="font-size: 18px;padding: 20px 0 10px;">
					<div class="titL">
						消费卡
						<span style="color:#409EFF;padding-left:10px;font-size: 16px;">（请扫描消费卡对应的条码）</span>
					</div>
				</div>
				<div style="padding-bottom:20px;">
					<el-input style="width: 370px;margin-left: 580px;" v-model="scanningCodeInput" >
						<template slot="prepend">手动录入条码</template>
					</el-input>
				</div>
				<el-table :data="tableData2" max-height='800' style="width: 100%;margin-bottom: 20px;">
					<el-table-column prop="goodsName" label="名称" width="300">
					</el-table-column>
					<el-table-column prop="customCode" label="条码" width="250">
					</el-table-column>
					<el-table-column prop="skuValue" label="规格">
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogState = false">取 消</el-button>
				<el-button type="primary" @click="add">确 定</el-button>
			</div>
		</el-dialog> -->
		<el-dialog title="使用记录" :visible.sync="dialogListState" width="1000px">
			<el-form >
				<el-row>
					<el-col :span="7">
						<el-form-item label="消费卡名称：" :label-width="'100px'">
							{{curRecord.card_category&&curRecord.card_category.name}}
						</el-form-item>
					</el-col>
					<el-col :span="5" >
						<el-form-item label="消费卡卡号：" :label-width="'100px'">
							{{curRecord.card_number}}
						</el-form-item>
					</el-col>
					<el-col :span="7" >
						<el-form-item label="服务名称：" :label-width="'100px'">
							{{curRecord.service_name}}
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="剩余次数：" :label-width="'100px'">
							{{curRecord.surplus_count}}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div class="form">
				<el-table :data="curRecord.consume_record" max-height='800' style="width: 100%;margin-bottom: 20px;">
					<el-table-column label="订单编号" width="200">
						<template slot-scope="scope">
							{{scope.row.order_num}}
						</template>
					</el-table-column>
					<el-table-column label="状态" width="150">
						<template slot-scope="scope">
							{{scope.row.consume_type===0?'退回':''}}
							{{scope.row.consume_type===1?'消费':''}}
						</template>
					</el-table-column>
					<el-table-column prop="shop_name"  label="服务地点" width="400">
					</el-table-column>
					<el-table-column label="消费日期">
						<template slot-scope="scope">
							{{$public.FTime(scope.row.consume_time)}}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	// import del from '@/util/del.js'
	export default {
		data() {
			return {
				tableData: [],
				dialogState:false,
				form:{
					"member_id": "",
					"name": "",
					"service_id": "",
					service_name:'',
					"consume_count": 10,
					"years": 10,
					"card_number": "",
					sku_value:'', 
					card_type:1, // 1：洗护卡；2：医疗套餐卡
				},
				serviceList:[],
				// washList:[{
				// 	label:'花生精致洗护-猫-长毛',
				// 	value:'5fcf3dce1be7db00012bd221',
				// },{
				// 	label:'花生精致洗护-猫-5kg以上',
				// 	value:'5fcf3db21be7db00012bd220',
				// },{
				// 	label:'花生精致洗护-猫-5kg以下',
				// 	value:'5fcf3d7a1be7db00012bd21f',
				// },{
				// 	label:'花生精致洗护-犬-0-3kg',
				// 	value:'5fcee1fc1be7db00012bd1e8',
				// },{
				// 	label:'花生精致洗护-犬-3-6kg',
				// 	value:'5fcee21e1be7db00012bd1e9',
				// },{
				// 	label:'花生精致洗护-犬-6-8kg',
				// 	value:'5fcee2851be7db00012bd1ea',
				// },{
				// 	label:'花生精致洗护-犬-8-12kg',
				// 	value:'5fcee33e1be7db00012bd1eb',
				// },{
				// 	label:'花生精致洗护-犬-12-15kg',
				// 	value:'5fcefea11be7db00012bd1ec',
				// },{
				// 	label:'花生精致洗护-犬-15-20kg',
				// 	value:'5fceff341be7db00012bd1ed',
				// },{
				// 	label:'花生精致洗护-犬-20-25kg',
				// 	value:'5fceffa01be7db00012bd1ee',
				// },{
				// 	label:'花生精致洗护-犬-25-35kg',
				// 	value:'5fceffe51be7db00012bd1ef',
				// },{
				// 	label:'花生精致洗护-犬-35-45kg',
				// 	value:'5fcf00051be7db00012bd1f0',
				// },{
				// 	label:'花生精致洗护-犬-特殊犬种',
				// 	value:'5fcf002c1be7db00012bd1f1',
				// }],
				// medicalList:[{
				// 	label:'生活圈-公犬去势套餐299',
				// 	value:'1000',
				// },{
				// 	label:'幼猫疫苗基础套餐',
				// 	value:'1001',
				// },{
				// 	label:'喵主子全年驱虫大行动',
				// 	value:'1002',
				// },{
				// 	label:'汪星人全年驱虫大行动',
				// 	value:'1003',
				// },{
				// 	label:'幼犬疫苗基础套餐',
				// 	value:'1004',
				// },{
				// 	label:'汪星人半年驱虫大行动',
				// 	value:'1005',
				// },{
				// 	label:'喵主子半年驱虫大行动',
				// 	value:'1006',
				// },{
				// 	label:'幼犬疫苗驱虫抗体检查豪华套餐（辉瑞卫佳八）',
				// 	value:'1007',
				// },{
				// 	label:'幼犬放心体检套餐',
				// 	value:'1008',
				// },{
				// 	label:'公猫呼吸麻醉去势安心套餐',
				// 	value:'1009',
				// },{
				// 	label:'幼猫疫苗驱虫抗体检查豪华套餐',
				// 	value:'1010',
				// },{
				// 	label:'幼猫放心体检套餐',
				// 	value:'1011',
				// },{
				// 	label:'母猫呼吸麻醉绝育安心套餐',
				// 	value:'1012',
				// },{
				// 	label:'年度豪华体检套餐',
				// 	value:'1013',
				// },{
				// 	label:'公犬去势安心套餐',
				// 	value:'1014',
				// },{
				// 	label:'母犬绝育安心套餐',
				// 	value:'1015',
				// },],
				formLabelWidth: '130px',
				scanningCode: '',
				scanningCodeInput:'',
				tableData2:[],
				o:null,
				// 消费记录
				dialogListState:false,
				curRecord:{consume_record:[]},
				
			}
		},
		props:{
			userId:{
				default:''
			}
		},
		watch:{
			
			userId:{
				handler(newVal){
				console.log(newVal,"n")
				this.tableData = []
				this.getTableData(newVal)
				},
				immediate: true
			},
			
		},
		mounted(){
			
		},
		methods: {
			// 获取表格数据
			getTableData(userId) {
				console.log(userId,"userId");
				this.$http.get('/api/Member/BindCards', {
					memberId:userId,  
				}).then(res => {
					if (res.code == 0) {
						this.tableData = res.data||[];
					}
				})
			},
			// 查看记录
			toConsumerCardRecord(consumerCard){
				this.curRecord = consumerCard;
				this.dialogListState=true;
			}
			// changeRadio
			// changeRadio(a){
			// 	this.form = {
			// 		"member_id": "",
			// 		"name": "",
			// 		"service_id": "",
			// 		service_name:'',
			// 		"consume_count":1,
			// 		"years": 10,
			// 		"card_number": "",
			// 		sku_value:'',
			// 		card_type:a,
			// 	}
			// 	if(a==1){
			// 		this.serviceList = this.washList;
			// 	}else if(a==2){
			// 		this.serviceList = this.medicalList;
			// 	}
			// 	this.o.init([])
			// 	this.tableData2 = this.o.arr;
			// },
			// // 打开弹窗
			// openDialog(){
			// 	this.form = {
			// 		"member_id": "",
			// 		"name": "",
			// 		"service_id": "",
			// 		service_name:'',
			// 		"consume_count":10,
			// 		"years": 10,
			// 		"card_number": "",
			// 		sku_value:'',
			// 		card_type:1,
			// 	}
			// 	this.o.init([])
			// 	this.tableData2 = this.o.arr;
			// 	this.dialogState = true;
			// },
			// 添加消费卡
			// add(){
			// 	if(this.form.service_id==''){
			// 		this.$message({
			// 			message: '请选择服务',
			// 			type: 'error'
			// 		});
			// 		return ;
			// 	}
			// 	let r = /^\+?[1-9][0-9]*$/;//正整数
			// 	if(!r.test(''+this.form.years)){
			// 		this.$message({
			// 			message:'有效期只能输入整数',
			// 			type: 'error'
			// 		});
			// 		return ;
			// 	}
			// 	if(this.tableData2.length==0){
			// 		this.$message({
			// 			message: '请录入消费卡',
			// 			type: 'error'
			// 		});
			// 		return ;
			// 	}
			// 	let params = {}
			// 	if(this.form.card_type==1){
			// 		let ids = ['5fcf3dce1be7db00012bd221','5fcf3db21be7db00012bd220','5fcf3d7a1be7db00012bd21f']
			// 		params = {
			// 			"member_id": this.$route.query.id,
			// 			"name": this.tableData2[0].goodsName,
			// 			"service_id": this.form.service_id,
			// 			service_name:this.$public.getMatchingItem(this.serviceList,'value',this.form.service_id).label,
			// 			"consume_count": ids.indexOf(this.form.service_id)==-1?10:6,
			// 			"years": this.form.years,
			// 			"card_number": this.tableData2[0].customCode,
			// 			sku_value:this.tableData2[0].skuValue,
			// 			card_type:this.form.card_type
			// 		};
			// 	}else if(this.form.card_type==2){
			// 		params = {
			// 			"member_id": this.$route.query.id,
			// 			"name": this.tableData2[0].goodsName,
			// 			"service_id": this.form.service_id,
			// 			service_name:this.$public.getMatchingItem(this.medicalList,'value',this.form.service_id).label,
			// 			"consume_count": 1,
			// 			"years": this.form.years,
			// 			"card_number": this.tableData2[0].customCode,
			// 			sku_value:this.tableData2[0].skuValue,
			// 			card_type:this.form.card_type
			// 		};
			// 	}
			// 	this.$http.post('/api/Member/BindCard',params).then(res => {
			// 		if (res.code == 0) {
			// 			this.$message({
			// 				message: '添加成功',
			// 				type: 'success'
			// 			});
			// 			this.getTableData();
			// 			this.dialogState = false;
			// 		}
			// 	})
			// },
			// 获取商品信息
			// getScanData(code) {
			// 	this.scanningCode=''
			// 	this.scanningCodeInput=''
			// 	this.o.init([]);
			// 	code = (code).toString().trim();
			
			// 	this.o.searchGoods(code,'',{can9:true}).then(res=>{
			// 		// 判断条码是否可用
			// 		if(res.customCodeStatus.id!==9){
			// 			this.$message({
			// 				message: '该卡未销售，不可绑定',
			// 				type: 'error'
			// 			});
			// 			return;
			// 		}else{
			// 			let addState = this.o.addGoods();
			// 			if(addState===true){
			// 				console.log('添加成功')
			// 			}
			// 		}
			// 		this.tableData2 = this.o.arr;
			// 	})
			// },
			// 查找条码
			// clickScanningCodeInput() {
			// 	if(!this.scanningCodeInput){
			// 		this.$message({
			// 			message: '请输入条码',
			// 			type: 'error'
			// 		});
			// 		return ;
			// 	}
			// 	this.getScanData(this.scanningCodeInput);
			// },
		},
		beforeDestroy(){
			// document.onkeypress=()=>{};
		}
	}
</script>

<style lang="scss" scoped>
	.components {
		background-color: #fff;
		border-radius: 6px;
		.searchLine {
			padding-bottom: 10px;
			.search {
				display: flex;
				justify-content: space-between;
				.searchL {
					.searchInput {
						width: 375px;
						margin-right: 10px;
					}
				}
				.searchR {
					margin-right: 20px;
				}
			}
			.fold{
				.select{
					margin-right: 20px;
				}
			}
		}
		.table{
			min-height: 400px;
		}
	}
</style>
